import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateSaveDialogData, TemplateSaveDialogResult } from './template-save-dialog.model';

@Component({
  standalone: false,
  selector: 'app-template-save-dialog',
  templateUrl: './template-save-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./template-save-dialog.component.scss']
})
export class TemplateSaveDialogComponent {
  name: string = '';
  isShared: boolean = false;
  organizationLevelId: string | null = null;

  get isValid(): boolean {
    return !!this.name.trim();
  }

  constructor(
    private dialogRef: MatDialogRef<TemplateSaveDialogComponent, TemplateSaveDialogResult | null>,
    @Inject(MAT_DIALOG_DATA) public data: TemplateSaveDialogData
  ) {
    this.name = data.defaultName ?? '';
  }

  onShareChange(event: { isShared: boolean; organizationLevelId: string | null }): void {
    this.isShared = event.isShared;
    this.organizationLevelId = event.organizationLevelId;
  }

  confirm(): void {
    if (!this.isValid) return;
    this.dialogRef.close({ name: this.name.trim(), isShared: this.isShared, organizationLevelId: this.organizationLevelId });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
